import React from 'react'
import numeral from 'numeral'
import { FormattedMessage } from 'react-intl'

export default ({ info = [] }) => {
  const current = info[0]
  let sum = null
  if (current) sum = `${numeral(current.bidsSum).format('0,0')} ${current.currencySymbol}`

  return (
    <div>
      {sum && <h1 className='Main__title Head'>
        <FormattedMessage id='fund_donation_stats.amount' />
        {' '}{sum}
      </h1>}
      {!sum && <h1 className='Main__title Head'>
        <FormattedMessage id='fund_donation_stats.no_funds' />
      </h1>}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Fund/DonationStats.jsx